import React, { useState, useEffect, useMemo } from "react";
import "../my component/style.css";

export default function Section3() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [hoveredProject, setHoveredProject] = useState(null);

  const projects = useMemo(() => [
    {
      id: 1,
      title: "Flappy Bird Game",
      description:
        "A simple Flappy Bird game built with HTML, CSS, and JavaScript",
      image: "/images/flappy-bird.png",
      tags: ["HTML", "CSS", "JavaScript"],
      github: "https://github.com/Chauhan-saab2006/flapy-bird",
      demo: "https://flapy-bird-box.netlify.app/",
      category: "frontend",
      featured: true,
    },
    {
      id: 2,
      title: "Code Maestro",
      description:
        "A website where I share my codes",
      image: "/images/code-miestro.png",
      tags: ["HTML", "Firebase", "Material-UI", "JavaScript", "Firebase Auth"],
      // github: null,
      demo: "https://code-miestro.netlify.app/",
      category: "frontend",
      featured: true,
    },
    {
      id: 3,
      title: "Music App",
      description:
        "A spotify clone",
      image: "/images/spotify.png",
      tags: ["JavaScript", "API", "CSS3", "Responsive"],
      github: "https://github.com/Chauhan-saab2006/music-app",
      demo: "https://apmamusic.netlify.app/",
      category: "fullstack",
      featured: false,
    },
    {
      id: 4,
      title: "Color Predict Game",
      description:
        "A responsive Color predict game",
      image: "/images/color predict.png",
      tags: ["HTML", "CSS", "JavaScript", "Responsive", "Firebase"],
      github: "https://github.com/Chauhan-saab2006/color_predict",
      demo: "https://color-predict.netlify.app/",
      category: "backend",
      featured: false,
    },
    {
      id: 5,
      title: "AI Assistant",
      description:
        "An AI Assistant by using Gemini API key",
      image: "/images/ai-assistant.png",
      tags: ["Python", "Gemini API", "Tkinter"],
      github: "https://github.com/Chauhan-saab2006/jarvis_2.0",
      demo: null,
      category: "backend",
      featured: false,
    },
  ], []);


  const categories = [
    { id: "all", label: "All Projects", count: projects.length },
    {
      id: "frontend",
      label: "Frontend",
      count: projects.filter((p) => p.category === "frontend").length,
    },
    {
      id: "backend",
      label: "Backend",
      count: projects.filter((p) => p.category === "backend").length,
    },
    {
      id: "fullstack",
      label: "Full Stack",
      count: projects.filter((p) => p.category === "fullstack").length,
    },
  ];

  useEffect(() => {
    if (activeFilter === "all") {
      setFilteredProjects(projects);
    } else {
      setFilteredProjects(
        projects.filter((project) => project.category === activeFilter)
      );
    }
  },  [activeFilter, projects]);

  const handleProjectHover = (projectId) => {
    setHoveredProject(projectId);
  };

  const handleProjectLeave = () => {
    setHoveredProject(null);
  };

  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        {/* Section Header */}
        <div className="projects-header">
          <div className="section-badge">Portfolio</div>
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-description">
            Explore my latest work and side projects that showcase my skills and
            passion for creating innovative solutions
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="filter-container">
          <div className="filter-tabs">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`filter-tab ${
                  activeFilter === category.id ? "active" : ""
                }`}
                onClick={() => setActiveFilter(category.id)}
              >
                <span className="filter-label">{category.label}</span>
                <span className="filter-count">{category.count}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className={`project-card ${project.featured ? "featured" : ""} ${
                hoveredProject === project.id ? "hovered" : ""
              }`}
              onMouseEnter={() => handleProjectHover(project.id)}
              onMouseLeave={handleProjectLeave}
            >
              {/* Project Image */}
              <div className="project-image-container">
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-image"
                />
                <div className="project-overlay">
                  <div className="project-actions">
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-action-btn github-btn"
                      aria-label="View on GitHub"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                      </svg>
                      <span>GitHub</span>
                    </a>
                    {project.demo && (
                      <a
                        href={project.demo}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-action-btn demo-btn"
                        aria-label="View Live Demo"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                        <span>Live Demo</span>
                      </a>
                    )}
                  </div>
                </div>
                {project.featured && (
                  <div className="featured-badge">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                    Featured
                  </div>
                )}
              </div>

              {/* Project Content */}
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tags">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="project-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
